/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NotificationsAliases {
  DECK_NOTIFICATIONS = 'deck-notifications',
  FETCH_NOTIFICATIONS = 'fetch-notifications',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  HPMS_DYNAMIC_DATE = 'hpms-dynamic-date',
  HPMS_NOTIFICATIONS = 'hpms-notifications',
  LAYOUT_0 = 'layout-0',
  LOADER_0 = 'loader-0',
  PANEL_LOADER = 'panel-loader',
  PANEL_NOTIFICATIONS = 'panel-notifications',
  PANEL_NOTIFY = 'panel-notify',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
}
export { NotificationsAliases };
